import { render, staticRenderFns } from "./MyAbouts.vue?vue&type=template&id=472ba0da"
import script from "./MyAbouts.vue?vue&type=script&lang=js"
export * from "./MyAbouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports